export default __webpack_public_path__ + "static/media/gallery_07.0fb0ef1c.jpg";